<template>
  <div class="create-page">
    <a-alert
      :message="messageTip"
      type="warning"
      show-icon
    />
    <a-steps
      :current="count - 1"
      class="create-steps"
    >
      <a-step
        v-for="(item, i) in steps"
        :key="item.title"
        :title="item.title"
      >
        <i
          v-if="count - 1 > i"
          slot="icon"
          class="iconfont iconicon-test94"
        />
        <span slot="description">{{ item.content }}</span>
      </a-step>
    </a-steps>
    <router-view />
    <!-- <component
      :is="componentName"
      ref="module"
      class="module"
    /> -->
  </div>
</template>

<script>
/* import First from './First'
import Second from './Second'
import Finish from './Finish' */

export default {
  components: {
    /* First,
    Second,
    Finish */
  },

  data () {
    return {
      steps: [
        {
          title: this.$t('message["1137"]'),
          content: this.$t('message["1647"]')
        },
        {
          title: this.$t('message["258"]'),
          content: this.$t('message["1014"]')
        },
        {
          title: this.$t('message["560"]'),
          content: this.$t('message["123"]')
        }
      ]
    }
  },

  computed: {
    count () {
      let { name } = this.$route
      let count = 1
      switch (name) {
        case 'configImportFirst':
          count = 1
          break
        case 'configImportSecond':
          count = 2
          break
        case 'configImportFinish':
          count = 3
          break
        default:
          count = 1
          break
      }

      return count
    },
    componentName () {
      let { count } = this
      let name = 'First'
      switch (count) {
        case 1:
          name = 'First'
          break
        case 2:
          name = 'Second'
          break
        case 3:
          name = 'Finish'
          break
      }
      return name
    },
    messageTip () {
      return this.$t('message["894"]')
    }

  }
}
</script>

<style lang="scss" scoped>
.ant-steps {
  padding: 20px 0 24px;
}

.ant-alert-warning {
  border-color: #F6A953;
}
.create-steps::v-deep {
  .ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
    max-width: 200px;
  }
  .ant-steps-item {
    margin-right: 6px;
  }
  .ant-steps-item:last-child {
    flex: 1;
  }
  .ant-steps-item-content {
    position: relative;
    width: calc(100% - 20px);
  }
  .ant-steps-item-title {
    position: static;
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    &:after{
      right: 0px;
      left: auto;
      top: 10px;
      width: 112px;
      height: 2px;
    }
  }
  .ant-steps-item-icon {
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    border-color: #42C27E;
  }
  .ant-steps-item-finish {
    .ant-steps-item-icon {
      color: #42C27E;
    }
    .ant-steps-icon {
      width: 20px;
      height: 20px;
      display: inline-block;
      line-height: 20px;
      color: #42C27E;
      .iconfont {
        float: left;
        font-size: 22px;
      }
    }
    .ant-steps-item-content > .ant-steps-item-title:after {
      background-color: #42C27E;
    }
  }

  .ant-steps-item-process {
    .ant-steps-item-icon {
      background: #42C27E
    }

  }

  .ant-steps-item-wait {
    .ant-steps-item-icon {
      background: #D6D6D6;
      border-color: #D6D6D6;
    }
    .ant-steps-icon {
      color: #fff;
    }
  }
}

</style>
<style lang="scss">
.create-steps {
  &.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
    max-width: 200px;
  }
}
</style>
